import { Fragment } from 'react';
import { ExpandMore, ErrorOutline } from '@material-ui/icons';

import { useBillingInfo } from './useBillingInfo';

import makeClasses from './BillingInfo.style';

import type { OrderDetailRawResp } from 'shared/infra';

export function BillingInfo({ userInfo }: Props) {
  const {
    isExpanded,
    height,
    contentRef,
    infoItems,
    disclaimerText,
    titleText,
    handleToggle,
  } = useBillingInfo(userInfo);

  const _classes = makeClasses();

  return (
    <section className={_classes.container}>
      <div
        className={_classes.header}
        onClick={handleToggle}
        data-is-expanded={isExpanded}
      >
        <span className={_classes.headerText}>{titleText}</span>
        <ExpandMore className={`${_classes.expandIcon}`} />
      </div>
      <div
        className={_classes.collapseContainer}
        style={{ height: `${height}px` }}
      >
        <div ref={contentRef} className={_classes.content}>
          <div className={_classes.billAlert}>
            <ErrorOutline className={_classes.alertIcon} />
            <span
              className={_classes.alertMessage}
              dangerouslySetInnerHTML={{ __html: disclaimerText }}
            />
          </div>
          <dl>
            {infoItems.map(field => (
              <Fragment key={field.key}>
                <dt>{field.label}</dt>
                <dd>{field.value}</dd>
              </Fragment>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}

interface Props {
  userInfo: OrderDetailRawResp['user'];
}
